import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import InputField from 'src/common/formFields/InputField';
import SelectField from 'src/common/formFields/SelectField';
import { useSelector } from 'react-redux';

export default function CardDetailsForm(props) {
  const {
    formField: {
      siteId,
      vehicleId,
      dispenserId,
      operatorId,
      driverId,
      cardType,
      cardInterface,
      cardUID,
      cardCategory,
      fuelType
    },
    initValues,
    onSiteChange,
    hasSelectedSite,
    requiredHintText
  } = props;
  const { vehicleList } = useSelector((state) => state.vehicles);
  const { allSites } = useSelector((state) => state.sites);
  const { allDispensers } = useSelector((state) => state.dispensers);
  const { operatorList } = useSelector((state) => state.operators);
  const { driverList } = useSelector((state) => state.drivers);

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} sm={6}>
        <SelectField
          name={siteId.name}
          label={`${siteId.label} *`}
          data={allSites}
          onChange={onSiteChange}
          required
          requiredHintText={requiredHintText}
          fullWidth
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <SelectField
          name={vehicleId.name}
          label={vehicleId.label}
          data={hasSelectedSite ? vehicleList : []}
          disabled={!hasSelectedSite}
          fullWidth
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <SelectField
          name={dispenserId.name}
          label={`${dispenserId.label} *`}
          data={allDispensers}
          required
          requiredHintText={requiredHintText}
          fullWidth
          multiple
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <SelectField
          name={operatorId.name}
          label={operatorId.label}
          data={hasSelectedSite ? operatorList : []}
          disabled={!hasSelectedSite}
          fullWidth
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <SelectField
          name={driverId.name}
          label={driverId.label}
          data={hasSelectedSite ? driverList : []}
          disabled={!hasSelectedSite}
          fullWidth
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <SelectField
          name={cardType.name}
          label={`${cardType.label} *`}
          data={cardType.data}
          required
          requiredHintText={requiredHintText}
          fullWidth
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <SelectField
          name={cardInterface.name}
          label={`${cardInterface.label} *`}
          data={cardInterface.data}
          required
          requiredHintText={requiredHintText}
          fullWidth
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <SelectField
          name={cardCategory.name}
          label={`${cardCategory.label} *`}
          data={cardCategory.data}
          required
          requiredHintText={requiredHintText}
          fullWidth
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <SelectField
          name={fuelType.name}
          label={fuelType.label}
          data={fuelType.data}
          fullWidth
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <InputField disabled={initValues} name={cardUID.name} label={`${cardUID.label} *`} required requiredHintText={requiredHintText} fullWidth upperCase />
      </Grid>
    </Grid>
  );
}

CardDetailsForm.propTypes = {
  formField: PropTypes.object.isRequired,
  initValues: PropTypes.bool,
  onSiteChange: PropTypes.func,
  hasSelectedSite: PropTypes.bool,
  requiredHintText: PropTypes.string,
};
